import { AvTelemetryClientContext } from 'src/app/features/video-conference/av-telemetry/models/av-telemetry.model';

/**
 * Chime payload shapes riding inside AvTelemetryEnvelope.payload. Chime's own vocabulary is
 * preserved deliberately — renaming is the translator's job.
 */

/** Trailing window of Chime `meetingHistory` retained per event, per AWS guidance. */
export const CHIME_MEETING_HISTORY_WINDOW_MS = 120_000;

export interface ChimeSessionRef {
  meetingId: string;
}

export interface ChimeTickPayload extends ChimeSessionRef {
  /** Verbatim `ClientMetricReport.getObservableMetrics()`. */
  session: Record<string, number>;
  video: Record<string, Record<string, unknown>>;
}

export interface ChimeMetaPayload extends ChimeSessionRef, AvTelemetryClientContext {
  attendeeId: string;
  mediaRegion: string | null;
}

export interface ChimeEventPayload extends ChimeSessionRef {
  name: string;
  attributes: Record<string, unknown>;
  history?: ChimeHistoryEntry[];
}

export interface ChimeHistoryEntry {
  name: string;
  timestampMs: number;
}

/** Synthetic event names for AudioVideoObserver signals absent from `eventDidReceive`. */
export enum ChimeSyntheticEventName {
  ConnectionDidBecomePoor = 'connectionDidBecomePoor',
  ConnectionDidBecomeGood = 'connectionDidBecomeGood',
  /** Recorded in-band: otherwise a missing event stream looks like a session with no issues. */
  EventControllerUnavailable = 'eventControllerUnavailable',
}
